import { createActions } from '../utils/actions';

const { actions: mediaLibrary } = createActions('mediaLibrary')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('createFolder')
  .addAsync('deleteFolder')
  .addAsync('deleteImages')
  .addAsync('downloadImages')
  .addAsync('getFolders')
  .addAsync('getImages')
  .addAsync('moveImages')
  .addAsync('renameFolder')
  .add('setValue')
  .add('toggleImageState')
  .addAsync('uploadFiles');

export default mediaLibrary;
